import { useTranslate } from 'react-polyglot';

import { InfoFilledIcon } from '@genially/icons';

import { useHostGameContext } from '../../../../HostGame.context';
import { SidebarLink } from '../SidebarLink/SidebarLink';

export const HideInstructionsSidebarLink = () => {
  const t = useTranslate();

  const { settingsSidebar, instructions } = useHostGameContext();

  const handleClick = () => {
    instructions.toggle();
    settingsSidebar.close();
  };

  const text = instructions.isVisible
    ? t('__new.play.shared.hideInstructions')
    : t('__new.play.shared.showInstructions');

  return <SidebarLink Icon={InfoFilledIcon} text={text} onClick={handleClick} />;
};
